<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="customerName">
        <el-input v-model="queryParams.customerName" filterable placeholder="客户名称" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="linkman">
        <el-input v-model="queryParams.linkman" placeholder="联系人" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="linkmanPhone">
        <el-input v-model="queryParams.linkmanPhone" filterable placeholder="联系电话" @keyup.enter.native="search" clearable/>
      </el-form-item>
      <el-form-item  prop="salesman">
        <el-input v-model="queryParams.salesman" placeholder="业务员" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="createUsername">
        <el-input v-model="queryParams.createUsername" placeholder="创建人" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
    <el-form-item  prop="dateRange">
        <el-date-picker
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                v-model="searchTime"
                @change="search"
                type="daterange"
                range-separator="-"
                start-placeholder="创建开始日期"
                end-placeholder="创建结束日期">
        </el-date-picker>
    </el-form-item>

      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="primary" icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="adds" v-hasPermi="['customer:information:add']">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" ref="tableData" border v-loading="loading">
      <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
      <el-table-column prop="customerName" label="客户名称" align="center" width="260" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="linkman" label="联系人" align="center"  :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="linkmanPhone" label="联系电话" align="center" min-width="110" ></el-table-column>
      <el-table-column prop="companyAddress" label="公司地址" align="center" min-width="160" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="useDevice" label="使用设备" align="center" min-width="90" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="useScreen" label="使用场景" align="center" min-width="120" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="salesman" label="业务员" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="createUsername" label="创建人" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center" min-width="140" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.createTime,'{y}-{m}-{d} {h}:{m}') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="审核状态" align="center" min-width="100">
          <template slot="header">
              <el-tooltip content="审核中表示提交成功" placement="top">
                  <i class="el-icon-question"></i>
              </el-tooltip>
              审核状态
          </template>
        <template slot-scope="{ row }">
          <el-tag v-if="row.status == '0'">待提交</el-tag>
          <el-tag v-else-if="row.status == '1'">审核中</el-tag>
          <el-tag v-else-if="row.status == '2'" type="success">审核通过</el-tag>
          <el-tag v-else-if="row.status == '3'" type="danger">审核驳回</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" align="center" min-width="160" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column label="操作" min-width="140" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" icon="el-icon-view" @click="detailInfo(scope.row)">详情</el-button>
          <el-dropdown @command="(command) => handleCommand(command, scope.row)" v-if="hasDropdownItems(scope.row)">
            <span class="el-dropdown-link">
              <i class="el-icon-d-arrow-right el-icon--right"></i>更多
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-hasPermi="['customer:information:update']" command="edit" v-if="scope.row.status == 0 || scope.row.status == 3" icon='el-icon-edit'>编辑</el-dropdown-item>
              <el-dropdown-item v-hasPermi="['customer:information:del']"         command="del" v-if="scope.row.status == 0" icon="el-icon-delete">删除</el-dropdown-item>
              <el-dropdown-item v-hasPermi="['customer:information:flowView']"    command="viewProcess" v-if="scope.row.status != 0" icon="el-icon-view">查看流程</el-dropdown-item>
              <el-dropdown-item v-hasPermi="['customer:information:verify']"      command="verifyProcess" v-if="scope.row.status ==1" icon="el-icon-s-check">审核</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
  </div>
</template>
<script>
import { selectCustomerInformationList, delCustomerInfo } from "@/api/api.js"; //查询客户信息列表

export default {
  name: "customerInformation",
  data() {
    return {
      loading: false,
      queryParams: {
        customerName:undefined,
        salesman:undefined,
        createUsername:undefined,
        linkman:undefined,
        linkmanPhone:undefined
      },
      tableData: [],
      searchTime: [],
      page: 1,
      pageSize: 20,
      total: 0,
      rules: {
        phone: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
      },
      agentOptions: [],
      // 排序方式
      sortOrder: "",
      // 排序名称
      sortName: "",
    };
  },
  computed: {
    adminShow() {
      return this.$store.getters.user.userType == '1';
    },
  },
  methods: {
    hasDropdownItems(row) {
      return (
        (this.checkPermi(['customer:information:update']) && (row.status == 0 || row.status == 3)) ||
        (this.checkPermi(['customer:information:del']) && row.status == 0) ||
        (this.checkPermi(['customer:information:flowView']) && row.status != 0) ||
        (this.checkPermi(['customer:information:verify']) && row.status == 1)
      );
    },
    // 搜索
    search() {
      this.tableData = [];
      this.page = 1;
      this.initData();
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.searchTime = [];
      this.search();
    },
    handleCommand(command, row) {
      switch (command) {
        case "edit":
          this.edit(row);
          break;
        case "del":
          this.removeCusInfo(row);
          break;
        case "viewProcess":
          this.flowDetail(row);
          break;
        case "verifyProcess":
          this.verifyCustomer(row);
          break;
        default:
          break;
      }
    },
    changeSwitch($event) {
    },
    // 获取列表的数据
    initData() {
      let params = {
        model: {
          ... this.addDateRange(this.queryParams, this.searchTime),
          order: this.sortOrder,
          sort: this.sortName,
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      this.loading = true;
      this.tableData = [];
      selectCustomerInformationList(params).then((res) => {
        this.loading = false;
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      });
    },
    // 查看审批流程
    flowDetail(row) {
      this.$router.push({
        path: "/customerInformation/customerInformationFlowView",
        query: {id: row.id, processId: row.flowId}
      });
    },
    // 查看
    detailInfo(row) {
      this.$router.push({
        path: "/customerInformation/customerInformationDetail",
        query: {id: row.id, processId: row.flowId}
      });
    },
    // 新增客户信息
    adds() {
      this.$router.push("/customerInformation/customerInformationAdd");
    },
    //修改客户信息
    edit(row) {
      this.$router.push({
        path: "/customerInformation/customerInformationUpdate",
        query: { id: row.id }
      });
    },
    //删除客户信息
    removeCusInfo(row) {
      this.$modal.confirm('是否确认删除名称为"' + row.customerName + '"的数据项？').then(function() {
        return delCustomerInfo({id: row.id});
      }).then(() => {
        this.initData();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    },
    verifyCustomer(row) {
      this.$router.push({
        path: "/customerInformation/flowCustomerAct",
        query: {id: row.id, processId: row.flowId}
      });
    },
  },
  mounted() {
    this.initData();
  },
  created() {},
  watch: {
    '$route': {
      handler: function (to, from) {
        if (to.name == "customerInformation") {
          this.initData();
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
};
</script>
<style scoped lang="less">

</style>


